module.exports = __webpack_public_path__ + "static/media/builtinv2-Шкаф тклкеос.fa76a68e.png";